export default function (characterLimit: number, value: string) {
  return value.slice(0, characterLimit);
}
